import React from 'react';
import {Container, Row, Col} from 'reactstrap';
//swiper
import "swiper/css";
import "swiper/css/pagination";

import image2_4 from "../../../assets/images/Project/2.4.png";
import image2_5 from "../../../assets/images/Project/2.5.png";
import image2_6 from "../../../assets/images/Project/2.6.png";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../../config';

const Trending = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <section className="section bg-light" id="categories">
                <Container fluid>
                    <Row className="justify-content-center">
                        <Col lg={5}>
                            <div className="text-center mb-5">
                                <h2 className="mb-3 fw-semibold lh-base">
                                    {t('t-salary-products-head').replace('{appName}', appConfig.appName)}
                                </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className='justify-content-center'>
                        <Col lg={9}>
                            <Row>
                                <Col lg={4} className="product-item">
                                    <div className="card explore-box card-animate h-100">
                                        <div className="text-center mt-4 p-2">
                                            <span className="rounded-circle badge badge-soft-success p-3">
                                                <img className='avatar-sm' src={image2_4} alt=''/>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            <h3 className="text-center">
                                                {t('t-salary-products1')}
                                            </h3>
                                            <p className="text-muted my-2 text-center fs-17 pt-3">
                                                {t('t-salary-products1-desc')}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="product-item">
                                    <div className="card explore-box card-animate h-100">
                                        <div className="text-center mt-4 p-2">
                                            <span className="rounded-circle badge badge-soft-success p-3">
                                                <img className='avatar-sm' src={image2_5} alt=''/>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            <h3 className="text-center">
                                                {t('t-salary-products2')}
                                            </h3>
                                            <p className="text-muted my-2 text-center fs-17 pt-3">
                                                {t('t-salary-products2-desc').replace('{appName}', appConfig.appName)}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="product-item">
                                    <div className="card explore-box card-animate h-100">
                                        <div className="text-center mt-4 p-2">
                                            <span className="rounded-circle badge badge-soft-success p-3">
                                                <img className='avatar-sm' src={image2_6} alt=''/>
                                            </span>
                                        </div>
                                        <div className="card-body">
                                            <h3 className="text-center">{t('t-salary-products3')}</h3>
                                            <p className="text-muted my-2 text-center fs-17 pt-3">
                                                {t('t-salary-products3-desc').split('{medPlus}')[0]}
                                                <span className='text-primary fw-semibold'> med</span><span
                                                className='text-danger fw-semibold'>Plus </span>
                                                {t('t-salary-products3-desc').split('{medPlus}')[1]}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Trending;